import clsx from 'clsx';
import React from 'react';

import IconOrgChartWithText from '@components/Images/Rebranding/IconOrgChartWithText';
import LazyImgixImage from '@components/LazyImgixImage';
import { Theme } from '@interfaces/global';

import { companies } from '../constants';

export interface CompanyLogo {
  className: string;
  name: string;
  path: string;
}

interface CompaniesProps {
  theme?: Theme;
  companiesLogo?: CompanyLogo[];
}

const Companies = ({ companiesLogo = companies, theme = Theme.Dark }: CompaniesProps) => {
  return (
    <div className="mt-48 flex flex-wrap items-center justify-center gap-x-32 gap-y-16 sm:mt-80">
      <div className="inline-flex w-full justify-center border-0 bg-transparent p-0 sm:w-auto">
        <IconOrgChartWithText
          className="w-[148px] md:w-[174px]"
          logoColor={theme === Theme.Dark ? 'white' : 'black'}
        />
      </div>
      {companiesLogo.map(({ name, className, path }) => (
        <LazyImgixImage
          key={name}
          alt={`${name} logo`}
          className="h-full w-full"
          src={path}
          sizes="100px"
          wrapperClassName={clsx(className, '!flex')}
        />
      ))}
    </div>
  );
};

export default Companies;
